// Recently Viewed Products Tracker
(function() {
  // Only run this on product pages
  if (!document.querySelector('.product') && !document.querySelector('[data-section-type="product"]')) {
    return;
  }

  // Function to set cookie
  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  // Get current product handle from the URL
  // We need the handle (not ID) for reliable product lookup
  const urlPath = window.location.pathname;
  const productHandleMatch = urlPath.match(/\/products\/([^\/\?#]+)/);
  
  if (productHandleMatch && productHandleMatch[1]) {
    // Store the product handle in the cookie
    const productHandle = productHandleMatch[1];
    console.log('Storing product handle in cookie:', productHandle);
    setCookie('recently_viewed_handle', productHandle, 30);
  } else {
    console.warn('Recently viewed products: Could not find product handle in URL');
  }
})();